"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadarChart = void 0;
/* eslint-disable no-magic-numbers */
/* eslint-disable max-lines-per-function */
const React = __importStar(require("react"));
const radar_1 = require("@nivo/radar");
const chart_theme_1 = require("./chart-theme");
exports.RadarChart = ({ data, keys, indexName }) => (React.createElement(radar_1.ResponsiveRadar, { theme: chart_theme_1.defaultChartTheme, data: data, keys: keys, indexBy: indexName, maxValue: "auto", margin: { top: 50, right: 130, bottom: 50, left: 60 }, curve: "linearClosed", borderWidth: 2, borderColor: { from: 'color', modifiers: [['darker', 1.6]] }, gridLevels: 5, gridShape: "circular", gridLabelOffset: 25, enableDots: true, dotSize: 10, dotColor: { theme: 'background' }, dotBorderWidth: 2, dotBorderColor: { from: 'color' }, dotLabel: "value", dotLabelYOffset: -12, fillOpacity: 0.25, blendMode: "multiply", animate: true, isInteractive: true, colors: { scheme: 'nivo' }, legends: [
        {
            anchor: 'top-left',
            direction: 'column',
            translateX: -50,
            translateY: -40,
            itemWidth: 80,
            itemHeight: 20,
            itemTextColor: '#999',
            symbolSize: 12,
            symbolShape: 'circle',
            effects: [
                {
                    on: 'hover',
                    style: {
                        itemTextColor: '#000',
                    },
                },
            ],
        },
    ] }));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmFkYXJDaGFydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jaGFydHMvUmFkYXJDaGFydC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVILHFDQUFxQztBQUNyQywyQ0FBMkM7QUFFM0MsNkNBQStCO0FBQy9CLHVDQUE4QztBQUU5QywrQ0FBa0Q7QUFRckMsUUFBQSxVQUFVLEdBQUcsQ0FBQyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFrQixFQUFFLEVBQUUsQ0FBQyxDQUN2RSxvQkFBQyx1QkFBZSxJQUNkLEtBQUssRUFBRSwrQkFBaUIsRUFDeEIsSUFBSSxFQUFFLElBQUksRUFDVixJQUFJLEVBQUUsSUFBSSxFQUNWLE9BQU8sRUFBRSxTQUFTLEVBQ2xCLFFBQVEsRUFBQyxNQUFNLEVBQ2YsTUFBTSxFQUFFLEVBQUUsR0FBRyxFQUFFLEVBQUUsRUFBRSxLQUFLLEVBQUUsR0FBRyxFQUFFLE1BQU0sRUFBRSxFQUFFLEVBQUUsSUFBSSxFQUFFLEVBQUUsRUFBRSxFQUNyRCxLQUFLLEVBQUMsY0FBYyxFQUNwQixXQUFXLEVBQUUsQ0FBQyxFQUNkLFdBQVcsRUFBRSxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsU0FBUyxFQUFFLENBQUMsQ0FBQyxRQUFRLEVBQUUsR0FBRyxDQUFDLENBQUMsRUFBRSxFQUM1RCxVQUFVLEVBQUUsQ0FBQyxFQUNiLFNBQVMsRUFBQyxVQUFVLEVBQ3BCLGVBQWUsRUFBRSxFQUFFLEVBQ25CLFVBQVUsUUFDVixPQUFPLEVBQUUsRUFBRSxFQUNYLFFBQVEsRUFBRSxFQUFFLEtBQUssRUFBRSxZQUFZLEVBQUUsRUFDakMsY0FBYyxFQUFFLENBQUMsRUFDakIsY0FBYyxFQUFFLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxFQUNqQyxRQUFRLEVBQUMsT0FBTyxFQUNoQixlQUFlLEVBQUUsQ0FBQyxFQUFFLEVBQ3BCLFdBQVcsRUFBRSxJQUFJLEVBQ2pCLFNBQVMsRUFBQyxVQUFVLEVBQ3BCLE9BQU8sUUFDUCxhQUFhLFFBQ2IsTUFBTSxFQUFFLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRSxFQUMxQixPQUFPLEVBQUU7UUFDUDtZQUNFLE1BQU0sRUFBRSxVQUFVO1lBQ2xCLFNBQVMsRUFBRSxRQUFRO1lBQ25CLFVBQVUsRUFBRSxDQUFDLEVBQUU7WUFDZixVQUFVLEVBQUUsQ0FBQyxFQUFFO1lBQ2YsU0FBUyxFQUFFLEVBQUU7WUFDYixVQUFVLEVBQUUsRUFBRTtZQUNkLGFBQWEsRUFBRSxNQUFNO1lBQ3JCLFVBQVUsRUFBRSxFQUFFO1lBQ2QsV0FBVyxFQUFFLFFBQVE7WUFDckIsT0FBTyxFQUFFO2dCQUNQO29CQUNFLEVBQUUsRUFBRSxPQUFPO29CQUNYLEtBQUssRUFBRTt3QkFDTCxhQUFhLEVBQUUsTUFBTTtxQkFDdEI7aUJBQ0Y7YUFDRjtTQUNGO0tBQ0YsR0FDRCxDQUNILENBQUMifQ==